/**
 * 全站http配置
 *
 * header参数说明
 * serialize是否开启form表单提交
 * isToken是否需要token
 */
// import { getToken } from '@/util/auth';
import { getUserInfo, serialize } from "@/util/utils";

import axios from "axios";
import { Message } from "element-ui";
import { setCookie } from "@/util/auth";
const storge = sessionStorage;
axios.defaults.timeout = 20000;
// 返回其他状态吗
axios.defaults.validateStatus = function(status) {
  return status >= 200 && status <= 500; // 默认的
};
// 跨域请求，允许保存cookie
axios.defaults.withCredentials = true;
axios.interceptors.request.use(
  config => {
    const userAccount = getUserInfo(); // getStore({ name: 'userInfo' });
    if (userAccount) {
      config.headers.Authorization = "Basic c2FiZXI6c2FiZXJfc2VjcmV0";
      if (userAccount.token_type && userAccount.access_token) {
        config.headers["Blade-Auth"] =
          userAccount.token_type + " " + userAccount.access_token; // 让每个请求携带token  暂时设置
      } else {
        //config.headers["Blade-Auth"] ='';// 让每个请求携带token  暂时设置
      }
    }
    // headers中配置serialize为true开启序列化
    if (config.methods === "post" && config.headers.serialize) {
      config.data = serialize(config.data);
      delete config.data.serialize;
    }
    return config;
  },
  error => {
    Message.closeAll();
    return Promise.reject(error);
  }
);
// HTTPresponse拦截
axios.interceptors.response.use(
  res => {
    const status = Number(res.status) || 200;
    const message = res.data.message || res.data.msg || "未知错误";
    if (status === 401) {
      // storge.removeItem("token");
      // storge.removeItem("userName");
      // storge.removeItem("userInfo");
      // storge.removeItem("tagList");
      if (window.location.href.includes("ticket=")) {
        const ticket = window.location.href.split("ticket=")[1].split("#/")[0];
        if (ticket) {
          setCookie(ticket);
          storge.setItem("ticket", ticket);
          storge.setItem("isAdmin", "0");
          storge.setItem("linkto", window.location.href.split("?")[0]);
          //  window.location.href = "/login/#/";
        }
      } else {
        // window.location.reload();
      }
    }
    if (status === 400) {
      Message.closeAll();
      Message({
        message: message,
        type: "error"
      });
      return Promise.reject(new Error(message));
    }
    // 如果是白名单类型放入catch自行处理
    if (status !== 200) {
      return Promise.reject(res);
    }
    return res.data;
  },
  error => {
    if (error.status === 500) {
      const message = error.data.message || "未知错误";
      Message.closeAll();
      Message({
        message: message,
        type: "error"
      });
      return Promise.reject(new Error(message));
    }
  }
);

export default axios;
